import React, {FC, ReactElement, useState, useEffect, useMemo} from 'react';
import { Avatar, Divider, Button, Modal, Form, Input, Upload, message  } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import styles from './index.less';
import IMember from 'types/IMember';
import { connect } from 'react-redux';
import { StoreState } from 'store'
import { useHistory, useLocation } from 'react-router-dom'
import { setMember } from 'store/actions'
import { removeToken } from 'api/request'
import api, { upFileUtil, BUCKET_ID } from 'api/xqjy-service'

interface IProps{
  member: IMember,
  setMember: (m: IMember)=>void
}

declare const ValidateStatuses: ["success", "warning", "error", "validating", ""];
declare type ValidateStatus = typeof ValidateStatuses[number];

const Header: FC<IProps> = (props: IProps) : ReactElement=> {

  const { member, setMember } = props
  const history = useHistory()
  const location = useLocation()
  const [visible, setVisible] = useState<boolean>(false)
  const [currentMenuIdx, setCurrentMenuIdx] = useState(0)
  const [, setTitle] = useState('')
  const [logoUrl, setLogoUrl] = useState(require('assets/images/logo.png').default)

  const logout = ()=>{
    setMember({
      memberId: null,
      name: ""
    })
    removeToken()
    history.push('/login')
  }


  const menuItemList = useMemo(()=>{
    if(member && member.roleCodes && member.roleCodes.indexOf('STUDENT')>=0){
      return [{
        title: '虚拟漫游',
        path: '/'
      },{
        title: '虚拟实验',
        path: '/xnsy'
      },{
        title: '实验数据',
        path: '/xnsy/report'
      },{
        title: '虚拟资源',
        path: '/res'
      }]
    }
    return [{
      title: '幼儿园环境',
      path: '/'
    },{
      title: '幼儿园成员',
      path: '/staff/list'
    },{
      title: '幼儿园活动',
      path: '/activity'
    },{
      title: '虚拟实验',
      path: '/xnsy'
    },{
      title: '实验数据',
      path: '/xnsy/report'
    },{
      title: '虚拟资源',
      path: '/res'
    }]
  }, [member])

  useEffect(()=>{
    api.unauth.infoCfgDetail().then(result=>{
      if(result.data){
        const {sysTitle, logoUrl} = result.data
        if(sysTitle){
          setTitle(sysTitle)
        }else{
          setTitle('虚拟幼儿园教学平台')
        }
        if(logoUrl){
          setLogoUrl(logoUrl)
        }
      }
    })
  }, [])

  useEffect(() => {
    const pathname = location.pathname
    let idx = menuItemList.length-1
    for(;idx>=0;idx--){
      if(pathname.startsWith(menuItemList[idx].path))
        break
    }
    setCurrentMenuIdx(idx)
  }, [menuItemList, location.pathname])

  // 弹窗
  const InfoModal: FC = (mdProps):ReactElement=> {

    const [mod, setMod] = useState({avatar: member.avatar, loading: false})

    const [customVlidate, setCustomVlidate] = useState<{
      oldPwd: { validateStatus: ValidateStatus , help: string|null },
      pwd: { validateStatus: ValidateStatus, help: string|null },
      confirmPwd: { validateStatus: ValidateStatus, help: string|null }
    }>({
      oldPwd: { validateStatus: "" , help: null },
      pwd: { validateStatus: "", help: null },
      confirmPwd: { validateStatus: "", help: null }
    })

    const clearVlidate = ()=>{
      setCustomVlidate({
        oldPwd: { validateStatus: "" , help: null },
        pwd: { validateStatus: "", help: null },
        confirmPwd: { validateStatus: "", help: null }
      })
    }

    const layout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
    };
    const tailLayout = {
      wrapperCol: { offset: 6, span: 12 },
    };

    const uploadButton = (
      <div>
        {mod.loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>上传头像</div>
      </div>
    );
    
    function beforeUpload(file:any) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        message.error('仅支持jpg/png格式的图片!');
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error('文件大小不超过2MB!');
        return false
      }
      return true;
    }

    const customRequest = (args:any)=>{
      setMod({...mod, loading:true})
      // 上传文件
      const { file } = args
      upFileUtil(BUCKET_ID.AVATOR, file.name, file).then((data:any)=>{
        setMod({...mod, loading:false, avatar: data.url})
      }).catch(e=>{
        setMod({...mod, loading:false})
      })
    }
    
    const updateInfo = (values: any)=>{

      let v:boolean = true
      let vlidateTip: any = {}
      // 验证
      if(values.oldPwd || values.pwd || values.confirmPwd){
        if(!values.oldPwd){
          vlidateTip['oldPwd'] = { validateStatus: "error", help: '请输入旧密码' }
          v = false
        }
        if(!values.pwd){
          vlidateTip['pwd'] = { validateStatus: "error", help: '请输入新密码' }
          v = false
        }else if(values.pwd.length>16){
          vlidateTip['pwd'] = { validateStatus: "error", help: '密码长度16个字符内' }
          v = false
        }
        if(!values.confirmPwd){
          vlidateTip['confirmPwd'] = { validateStatus: "error", help: '请再次输入新密码' }
          v = false
        }else{
          if(values.pwd !== values.confirmPwd){
            vlidateTip['confirmPwd'] = { validateStatus: "error", help: '两次密码输入不一致' }
            v = false
          }
        }
      }
      if(!v){
        setCustomVlidate({
          ...customVlidate,
          ...vlidateTip
        })
        return
      }

      values['avatar'] = mod.avatar
      api.member.updInfo(values).then((result:any)=>{
        if(result.code !== 200){
          message.error(result.msg)
          return
        }
        setVisible(false)
        if(values.pwd){
          // 修改密码要重新登录
          message.success({
            content: '修改成功，请重新登录',
            onClose: ()=>{
              logout()
            }
          })
        }else{
          message.success('修改成功')
          api.member.currentInfo({}).then(result=>{
            setMember(result.data)
          })
        }
      })
    }

    return (
      <Modal 
        visible={visible} 
        title="资料设置" 
        footer={null}
        onCancel={()=>{setVisible(false)}} width={600} >
        
        <Form {...layout} onFinish={updateInfo} initialValues={member}>
          <Form.Item label="昵称" name="name" rules={[{ required: true, message: '请输入昵称' }]}>
            <Input placeholder="请输入昵称"/>
          </Form.Item>
          <Form.Item label="头像" >
            <Upload
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                beforeUpload={beforeUpload}
                customRequest={customRequest}
                //onChange={this.handleChange}
              >
                {mod.avatar ? <img src={mod.avatar} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
              </Upload>
              <div className="lab-color">支持jpg\png格式的图片，建议文件小于2M</div>
          </Form.Item>
          <Form.Item label="旧密码" name="oldPwd" validateStatus={customVlidate.oldPwd.validateStatus } help={customVlidate.oldPwd.help}>
            <Input.Password placeholder="不修改密码不用输入" onChange={clearVlidate}/>
          </Form.Item>
          <Form.Item label="新密码" name="pwd" validateStatus={customVlidate.pwd.validateStatus} help={customVlidate.pwd.help}>
            <Input.Password placeholder="数字与字母组合，不超过16个字符" onChange={clearVlidate}/>
          </Form.Item>
          <Form.Item label="确认密码" name="confirmPwd" validateStatus={customVlidate.confirmPwd.validateStatus} help={customVlidate.confirmPwd.help}>
            <Input.Password placeholder="请再次输入密码" onChange={clearVlidate}/>
          </Form.Item>
          <Form.Item {...tailLayout}>
            <Button type="primary" htmlType="submit">保存</Button>
          </Form.Item>
        </Form>

      </Modal>
    )
  }


  return (
    <div className={styles.header}>
      <InfoModal></InfoModal>
      <div className={styles.inner}>
        <div className={styles.logo}>
          <div className={styles.img}>
            <img alt="" src={logoUrl}></img>
          </div>
          <div className={styles.title}>
            <img alt="" src={require('assets/images/title.png').default}></img>
          </div>
        </div>
        <div className={styles.menu}>
          {
            menuItemList.map((item, idx)=>{
              return (
                <div key={item.path} className={`${styles.item} ${currentMenuIdx === idx ? styles.current : ''}`}>
                  <div className={styles.blank}></div>
                  <div className={styles.link}>
                    <a className="abtn" onClick={()=>{history.push(item.path)}}>{item.title}</a>
                  </div>
                  <div className={styles.underline}></div>
                </div>
              )
            })
          }
          
        </div>
        {
          member.memberId && (
            <div className={styles.right}>
              <div className={styles.user}>
                <div className={styles.avatar}>
                  <Avatar style={{width:'0.5rem', height:'0.5rem',fontSize:'0.18rem',lineHeight: '0.5rem'}} src={member.avatar}>{member.name}</Avatar>
                </div>
                <div className={styles.name}>
                  <a className="abtn" onClick={()=>{setVisible(true)}}>{member.name}</a>
                </div>
              </div>
              <Divider type="vertical"/>
              <div className={styles.logout}>
                <a className="abtn" onClick={logout}>退出</a>
              </div>
            </div>
          )
        }
        {
          !member.memberId && (
            <div className={styles.right}>
              <div className={styles.loginBtn}>
                <Button type="primary" shape="round" onClick={()=>{history.push('/login')}}>登录</Button>
              </div>
            </div>
          )
        }
      </div>
    </div>
  )
}

const mapStateToProps = (state: StoreState): { member: IMember } => ({
  member: state.member
})

const mapDispatchToProps = {setMember}

export default connect(mapStateToProps, mapDispatchToProps)(Header);